import { palette } from '@livable/saas-react-components';
import breakpointsFunc from '../breakpointsFunc';
const MuiAlert = {
  styleOverrides: {
    root: {
      padding: '40px 50px',
      boxShadow: 'none',
      justifyContent: 'center',
      '& .MuiTypography-h4, .MuiTypography-h5': {
        marginBottom: '4px'
      },
      '& a.MuiLink-root:not(.MuiLink-default-text)': {
        color: palette.shades[800],
        display: 'inline-block',
        fontSize: '15px',
        fontWeight: '600',
        lineHeight: '20px',
        fontFamily: palette.fontFamilies.poppins,
        marginTop: '16px'
      }
    },
    message: {
      padding: '0',
      flexGrow: '1',
      maxWidth: '1280px'
    },
    icon: {
      marginRight: '20px',
      padding: '0',
      fontSize: '33px',
      opacity: '1'
    },
    action: {
      marginLeft: '20px',
      padding: '0',
      marginRight: '0',
      '& .MuiIconButton-root': {
        padding: '0'
      },
      '& .MuiSvgIcon-root': {
        fontSize: '32px'
      }
    },
    brand: {
      background: palette.gradients.fade,
      '& .MuiAlert-action path': {
        fill: palette.shades[800]
      }
    },
    standardInfo: {
      background: palette.info.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.info.dark
      },
      '& .MuiAlert-icon path': {
        fill: palette.info.main
      },
      '& .MuiAlert-action path': {
        fill: palette.info.dark
      }
    },
    modalInfo: {
      background: palette.info.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.info.dark
      }
    },
    standardSuccess: {
      background: palette.success.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.success.dark
      },
      '& .MuiAlert-icon path': {
        fill: palette.success.main
      },
      '& .MuiAlert-action path': {
        fill: palette.success.dark
      }
    },
    modalSuccess: {
      background: palette.success.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.success.dark
      }
    },
    standardWarning: {
      background: palette.warning.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.warning.dark
      },
      '& .MuiAlert-icon path': {
        fill: palette.warning.main
      },
      '& .MuiAlert-action path': {
        fill: palette.warning.dark
      }
    },
    modalWarning: {
      background: palette.warning.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.warning.dark
      }
    },
    standardError: {
      background: palette.error.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.error.dark
      },
      '& .MuiAlert-icon path': {
        fill: palette.error.main
      },
      '& .MuiAlert-action path': {
        fill: palette.error.dark
      },
      '& .MuiLink-default-text': {
        textDecoration: 'underline',
        '&: hover': {
          color: palette.error.dark
        }
      }
    },
    modalError: {
      background: palette.error.gradient,
      // backgroundColor: palette.shades[100],
      '& .MuiTypography-root': {
        color: palette.error.dark
      }
    },
    defaultGrey: {
      background: palette.gradients.fade
    }
  },
  variants: [{
    props: {
      size: 'small'
    },
    style: {
      padding: '24px 40px'
    }
  }, {
    props: {
      variant: 'modal'
    },
    style: {
      marginTop: '-32px',
      marginLeft: '-40px',
      marginRight: '-40px',
      marginBottom: '0',
      padding: '24px 40px',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      [breakpointsFunc.breakpoints.down('lg')]: {
        marginLeft: '-24px',
        marginRight: '-24px',
        marginTop: '-40px',
        padding: '24px'
      }
    }
  }, {
    props: {
      variant: 'snackbar'
    },
    style: {
      width: '360px',
      backgroundColor: palette.shades[100],
      background: palette.gradients.white,
      display: 'inline-flex',
      border: "1px solid ".concat(palette.shades[300]),
      borderRadius: '2px',
      padding: '18px 24px',
      alignItems: 'center',
      boxShadow: palette.shadows.hard,
      position: 'relative',
      '& .MuiAlert-icon': {
        marginRight: '10px'
      },
      '&:hover': {
        '& .progress': {
          animationPlayState: 'paused'
        }
      },
      '& .MuiLinearProgress-root': {
        position: 'absolute',
        bottom: '0',
        left: '0',
        right: '0',
        backgroundColor: 'transparent',
        borderRadius: '0px 0px 1px 1px'
      },
      '& .MuiAlert-action': {
        '& .MuiSvgIcon-root': {
          fontSize: '24px'
        }
      },
      '& .MuiAlert-message': {
        textAlign: 'left'
      },
      '&.MuiAlert-snackbarSuccess': {
        background: palette.success.gradient,
        '& .MuiTypography-root': {
          color: palette.success.dark
        },
        '& .MuiAlert-icon path': {
          fill: palette.success.main
        },
        '& .MuiLinearProgress-bar': {
          background: palette.success.main
        }
      },
      '&.MuiAlert-snackbarInfo': {
        background: palette.info.gradient,
        '& .MuiTypography-root': {
          color: palette.info.dark
        },
        '& .MuiAlert-icon path': {
          fill: palette.info.main
        },
        '& .MuiLinearProgress-bar': {
          background: palette.info.main
        }
      },
      '&.MuiAlert-snackbarWarning': {
        background: palette.warning.gradient,
        '& .MuiTypography-root': {
          color: palette.warning.dark
        },
        '& .MuiAlert-icon path': {
          fill: palette.warning.main
        },
        '& .MuiLinearProgress-bar': {
          background: palette.warning.main
        }
      },
      '&.MuiAlert-snackbarError': {
        background: palette.error.gradient,
        '& .MuiTypography-root': {
          color: palette.error.dark
        },
        '& .MuiAlert-icon path': {
          fill: palette.error.main
        },
        '& .MuiLinearProgress-bar': {
          background: palette.error.main
        }
      }
    }
  }]
};
export default MuiAlert;